import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";

export const useSexAtBirthText = () => {
  const {t} = useTranslation(I18nNamespace.WEB_SCHEDULING);
  return t(
    "What gender does your insurance company reflect on file? Sometimes this is different than the gender you identify with.",
    {ns: "web-scheduling"},
  );
};
